import { __decorate, __metadata } from "tslib";
import { AppRequest } from '@core/shared/app-request';
import { AppRequestMethod } from '@core/shared/request';
import { Expose, Model, ModelId } from '@core/shared/model';
import { MediaAssetItem } from '../models';
let SyncMediaAssetMetadataResponse = /*#__PURE__*/(() => {
  let SyncMediaAssetMetadataResponse = class SyncMediaAssetMetadataResponse extends Model {};
  __decorate([Expose(), __metadata("design:type", MediaAssetItem)], SyncMediaAssetMetadataResponse.prototype, "updatedAsset", void 0);
  SyncMediaAssetMetadataResponse = __decorate([ModelId("SyncMediaAssetMetadataResponse") // auto-generated by sync-model-ids
  ], SyncMediaAssetMetadataResponse);
  return SyncMediaAssetMetadataResponse;
})();
export { SyncMediaAssetMetadataResponse };
let SyncMediaAssetMetadataRequest = /*#__PURE__*/(() => {
  let SyncMediaAssetMetadataRequest = class SyncMediaAssetMetadataRequest extends Model {
    static {
      this.Response = SyncMediaAssetMetadataResponse;
    }
  };
  __decorate([Expose(), __metadata("design:type", Number)], SyncMediaAssetMetadataRequest.prototype, "assetId", void 0);
  SyncMediaAssetMetadataRequest = __decorate([AppRequest('media', 'assets/sync-metadata', {
    httpMethod: AppRequestMethod.POST,
    simpleAbilityCheck: 'ADMINISTRATOR'
  }), ModelId("SyncMediaAssetMetadataRequest") // auto-generated by sync-model-ids
  ], SyncMediaAssetMetadataRequest);
  return SyncMediaAssetMetadataRequest;
})();
export { SyncMediaAssetMetadataRequest };